import React from 'react';

export const VenetianTiltLeft = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 108.6 63.1" {...props}>
      <path fill="#fff" d="M17.979 1.834h85.7v60.7h-85.7z" />
      <path
        d="M103.679 63.034h-85.7c-.3 0-.6-.3-.6-.6v-60.7c0-.3.3-.6.6-.6h85.7c.3 0 .6.3.6.6v60.7c0 .4-.2.6-.6.6zm-85.1-1.1h84.6v-59.5h-84.6v59.5z"
        fill="#dcd9d5"
      />
      <path fill="#fff" d="M17.979 1.834h85.7v60.7h-85.7z" />
      <path
        d="M103.679 63.034h-85.7c-.3 0-.6-.3-.6-.6v-60.7c0-.3.3-.6.6-.6h85.7c.3 0 .6.3.6.6v60.7c0 .4-.2.6-.6.6zm-85.1-1.1h84.6v-59.5h-84.6v59.5z"
        fill="#dcd9d5"
      />
      <g fill="#dcd9d5">
        <path d="M21.979 5.834h77.7v52.7h-77.7z" />
        <path d="M99.679 59.034h-77.7c-.3 0-.6-.3-.6-.6v-52.7c0-.3.3-.6.6-.6h77.7c.3 0 .6.3.6.6v52.7c0 .4-.2.6-.6.6zm-77.1-1.1h76.6v-51.5h-76.6v51.5z" />
      </g>
      <path
        d="M108.079 63.034h-94.4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h94.4c.3 0 .5.2.5.5s-.2.5-.5.5z"
        fill="#dcd9d5"
      />
      <g>
        <path d="M15.5 35.5h89.2l2.9 5.2h-95l2.9-5.2z" fill="#233762" />
        <path
          d="M108.3 41.1H11.8l3.4-6.2h89.7l3.4 6.2zm-94.9-.9h93.3l-2.3-4.2H15.8l-2.4 4.2z"
          fill="#fff"
        />
        <path d="M15.5 31.6h89.2l2.9 5.2h-95l2.9-5.2z" fill="#233762" />
        <path
          d="M108.3 37.3H11.8l3.4-6.2h89.7l3.4 6.2zm-94.9-1h93.3l-2.3-4.2H15.8l-2.4 4.2z"
          fill="#fff"
        />
        <path d="M15.5 27.7h89.2l2.9 5.2h-95l2.9-5.2z" fill="#233762" />
        <path
          d="M108.3 33.4H11.8l3.4-6.2h89.7l3.4 6.2zm-94.9-1h93.3l-2.3-4.2H15.8l-2.4 4.2z"
          fill="#fff"
        />
        <path d="M15.5 23.9h89.2l2.9 5.2h-95l2.9-5.2z" fill="#233762" />
        <path
          d="M108.3 29.5H11.8l3.4-6.2h89.7l3.4 6.2zm-94.9-.9h93.3l-2.3-4.2H15.8l-2.4 4.2z"
          fill="#fff"
        />
        <path d="M15.5 20h89.2l2.9 5.2h-95l2.9-5.2z" fill="#233762" />
        <path
          d="M108.3 25.7H11.8l3.4-6.2h89.7l3.4 6.2zm-94.9-1h93.3l-2.3-4.2H15.8l-2.4 4.2z"
          fill="#fff"
        />
        <g>
          <path d="M15.5 16.2h89.2l2.9 5.2h-95l2.9-5.2z" fill="#233762" />
          <path
            d="M108.3 21.8H11.8l3.4-6.2h89.7l3.4 6.2zm-94.9-.9h93.3l-2.3-4.2H15.8l-2.4 4.2z"
            fill="#fff"
          />
        </g>
        <g>
          <path d="M15.5 12.3h89.2l2.9 5.2h-95l2.9-5.2z" fill="#233762" />
          <path
            d="M108.3 18H11.8l3.4-6.2h89.7l3.4 6.2zm-94.9-1h93.3l-2.3-4.2H15.8L13.4 17z"
            fill="#fff"
          />
        </g>
        <g>
          <path d="M15.5 8.4h89.2l2.9 5.2h-95l2.9-5.2z" fill="#233762" />
          <path
            d="M108.3 14.1H11.8L15.2 8h89.7l3.4 6.1zm-94.9-1h93.3l-2.3-4.2H15.8l-2.4 4.2z"
            fill="#fff"
          />
        </g>
        <g>
          <path d="M15.5 4.6h89.2l2.9 5.2h-95l2.9-5.2z" fill="#233762" />
          <path
            d="M108.3 10.3H11.8l3.4-6.2h89.7l3.4 6.2zm-94.9-1h93.3l-2.3-4.2H15.8l-2.4 4.2z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M12.6.4h94.9v4.8H12.6z" />
          <path
            d="M107.9 5.6H12.2V0h95.7v5.6zM13 4.8h94.1v-4H13v4z"
            fill="#fff"
          />
        </g>
      </g>
      <circle
        cx={16.6}
        cy={41.4}
        r={16.1}
        fill="#fff"
        stroke="#233762"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
      <path
        d="M17.4 51h-1.7V3.3c0-.4.4-.8.8-.8h.1c.4 0 .8.4.8.8V51z"
        fill="#233762"
        stroke="#fff"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
    </svg>
  );
};
